import React, { useState } from 'react';
import MessageModal from './MessageModal';
import './styles.scss';

type SendMessageProps = {
  brandId: string;
  productName?: string;
  className?: string;
  children?: React.ReactNode;
  tel?: boolean;
  isInitOpen?: boolean;
};

const SendMessage: React.FC<SendMessageProps> = ({
  brandId,
  productName,
  className,
  children,
  tel,
  isInitOpen,
}) => {
  const [showModal, setShowModal] = useState(!!isInitOpen);

  return (
    <>
      <a
        onClick={() => setShowModal(true)}
        className={className || 'send-message-link'}
      >
        {children}
      </a>
      {showModal && (
        <MessageModal
          brandId={brandId}
          productName={productName}
          isShow={showModal}
          close={() => setShowModal(false)}
          tel={tel}
        />
      )}
    </>
  );
};

export default SendMessage;
